import { render, staticRenderFns } from "./AmbassadorReferralHistory.vue?vue&type=template&id=7653e4e2&"
import script from "./AmbassadorReferralHistory.vue?vue&type=script&lang=js&"
export * from "./AmbassadorReferralHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports